// extracted by mini-css-extract-plugin
export default {"list__container":"PeopleList_list__container__NwJ33","list__item":"PeopleList_list__item__mI12e","person__photo":"PeopleList_person__photo__q8VJk"};